const rb = require('crypto').randomBytes;

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}
function bytesToString(buf) {
  let i = 0;
  return byteToHex[buf[i++]] + byteToHex[buf[i++]] +
    byteToHex[buf[i++]] + byteToHex[buf[i++]] +
    byteToHex[buf[i++]] + byteToHex[buf[i++]] +
    byteToHex[buf[i++]] + byteToHex[buf[i++]] +
    byteToHex[buf[i++]] + byteToHex[buf[i++]] +
    byteToHex[buf[i++]] + byteToHex[buf[i++]] +
    byteToHex[buf[i++]] + byteToHex[buf[i++]] +
    byteToHex[buf[i++]] + byteToHex[buf[i++]];
}

function getRandomId(index) {
  // return bytesToString(rb(16));
  return genNonDuplicateID(index)
}

const randomLetter = function () {
  return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[parseInt(Math.random() * 26)].toLowerCase()
}

const randomLetters = function (times = 1) {
  let result = '';
  for (let i = 0; i < times; i++) {
    result += randomLetter();
  }
  return result;
}

export const genNonDuplicateID = (index = 0) => {
  return randomLetters(4) + Number(Math.random().toString().substr(3, 6) + Date.now() + index.toString()).toString(36);
};


export default getRandomId;



// WEBPACK FOOTER //
// ./src/utils/randomId.js